import { useWorkspace } from 'components/providers'
import dayjs from 'dayjs'
import { useDismissDateByItem } from '../../utils/preferences'
import ResourceUpsell from './ResourceUpsell'

export default function SubscriptionResourceUpsell() {
  const { subscription } = useWorkspace()
  const [dismissDateByItem, setDismissDateByItem] = useDismissDateByItem()

  const { plan, selectedResource } = subscription || {}
  if (plan !== 'basic') return null

  const dismissed = dayjs(dismissDateByItem?.subscriptionUpsell ?? 0)
    .add(1, 'month')
    .isAfter(dayjs())
  if (dismissed) return null

  function handleDismiss() {
    setDismissDateByItem({ subscriptionUpsell: dayjs().valueOf() })
  }

  return (
    <ResourceUpsell
      resourceName={selectedResource === 'event' ? 'facility' : 'event'}
      onDismiss={handleDismiss}
    />
  )
}
